var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3439({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 4.5,
    stroke: "#747BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7524 10H24.5684C27.1843 10 29.3212 12.1369 29.3212 14.7524V19.9337C29.3212 22.5495 27.1843 24.6861 24.5684 24.6861H20.8842L13.9385 30.7114C13.4306 31.151 12.6508 30.7772 12.6512 30.123L12.6489 24.6861H10.7524C8.13695 24.6861 6 22.5495 6 19.9337V14.7524C6 12.1369 8.13695 10 10.7524 10ZM20.9847 28.3995C19.9582 28.3995 19.9582 26.8386 20.9847 26.8386H22.9708C23.1878 26.8386 23.3843 26.927 23.5257 27.0699L29.3575 32.1288V27.619C29.3575 27.1878 29.7071 26.8386 30.138 26.8386H32.4695C34.2232 26.8386 35.661 25.4008 35.661 23.6471V18.4658C35.661 17.4392 37.2219 17.4392 37.2219 18.4658V23.6471C37.2219 26.2626 35.085 28.3995 32.4695 28.3995H30.9184L30.9162 33.8363C30.9165 34.4906 30.1368 34.8644 29.6289 34.4248L22.6832 28.3995H20.9847ZM24.5684 11.5609H10.7524C8.99868 11.5609 7.56094 12.9991 7.56094 14.7524V19.9337C7.56094 21.6874 8.99868 23.1252 10.7524 23.1252H13.4294C13.8603 23.1252 14.2099 23.4748 14.2099 23.9056V28.4157L20.0417 23.3568C20.1831 23.214 20.3796 23.1252 20.5965 23.1252H24.5684C26.3225 23.1252 27.7599 21.6874 27.7599 19.9337V14.7524C27.7599 12.9991 26.3221 11.5609 24.5684 11.5609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3439);
export default __webpack_public_path__ + "static/media/Group 3439.2bc37cac8186c3dc0accaa8d7cf567c8.svg";
export { ForwardRef as ReactComponent };